import React from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import StoryDisplay from "../StoryDisplay/StoryDisplay";

import { DetailsHomeWrapper } from "./component";

const DetailsStory = ({ details }) => {
	return (
		<DetailsHomeWrapper tw="p-4">
			<StoryDisplay story={details?.story} />
		</DetailsHomeWrapper>
	);
};

export default DetailsStory;